import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/articles';
import { articles } from '@/mocks/articles';
import { VerifiedBadge, channelName } from '@/components/feature/ArticleBits';

const ITEMS: { id: number; kicker: string; tag: string }[] = [
  { id: 8, kicker: '跳槽避坑系列', tag: '股权实战' },
  { id: 2, kicker: '平台生态观察', tag: '分成规则' },
  { id: 5, kicker: '行业独家追踪', tag: '研发变动' },
];

export default function DeepTopics() {
  const leads = ITEMS.map((it) => ({
    ...it,
    article: articles.find((a) => a.id === it.id) as Article,
  }));

  return (
    <section className="border-y border-background-200 bg-background-100/60 py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex items-center justify-between">
          <div>
            <p className="flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-accent-700">
              <i className="ri-newspaper-line" aria-hidden="true"></i>
              深度话题
            </p>
            <h2 className="mt-2 font-display text-2xl font-bold text-foreground-950 md:text-3xl">
              不止于八卦，更是能用的职场决策参考
            </h2>
          </div>
          <span className="hidden items-center gap-1.5 text-sm text-foreground-500 sm:flex">
            编辑部精选 <i className="ri-arrow-right-line text-primary-600" aria-hidden="true"></i>
          </span>
        </div>

        <div className="mt-8 flex flex-col gap-6">
          {leads.map(({ article: a, kicker, tag }, idx) => (
            <Link
              key={a.id}
              to={`/article/${a.id}`}
              className={`group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300 lg:flex-row ${
                idx % 2 === 1 ? 'lg:flex-row-reverse' : ''
              }`}
            >
              <div className="relative aspect-[16/9] overflow-hidden bg-background-200 lg:aspect-auto lg:w-1/2">
                <img
                  src={a.cover}
                  alt={a.title}
                  className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <span className="absolute left-4 top-4 rounded-full bg-foreground-950/85 px-3 py-1 text-xs font-medium text-background-50 backdrop-blur">
                  {kicker}
                </span>
              </div>
              <div className="flex flex-1 flex-col justify-center p-6 lg:p-10">
                <span className="text-xs font-medium text-primary-700">
                  {channelName[a.channel]} · {tag}
                </span>
                <h3 className="mt-2 font-display text-xl font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700 md:text-2xl">
                  {a.title}
                </h3>
                <p className="mt-3 line-clamp-3 text-sm leading-7 text-foreground-600 md:text-[15px]">{a.excerpt}</p>
                <div className="mt-5 flex items-center gap-3 text-xs text-foreground-500">
                  <VerifiedBadge status={a.verified} />
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line" aria-hidden="true"></i>
                    {a.views}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-chat-3-line" aria-hidden="true"></i>
                    {a.comments}
                  </span>
                </div>
                <span className="mt-6 inline-flex w-fit items-center gap-1.5 rounded-md bg-primary-600 px-4 py-2 text-xs font-semibold whitespace-nowrap text-background-50 transition-colors group-hover:bg-primary-500">
                  查看完整分析
                  <i className="ri-arrow-right-line" aria-hidden="true"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}